import InterviewDetailsPage from './interview-details-page'

export default InterviewDetailsPage